import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationFR from './locales/fr.json';
import translationEN from './locales/en.json';

i18n
  .use(LanguageDetector) // ✅ détecte automatiquement la langue du navigateur
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: translationFR },
      en: { translation: translationEN },
    },
    fallbackLng: 'en', // si la langue du navigateur n'est pas supportée
    interpolation: {
      escapeValue: false, // ✅ pas besoin d'échapper les valeurs avec React
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },
    debug: false,
  });

export default i18n;
